import NetworkService, { Endpoint } from './NetworkService'

export default class PamiaService {
  network
  constructor() {
    this.network = new NetworkService()
  }
  getWebviewUrl() {
    return this.network.get(Endpoint.pamiaWebviewUrl)
  }
}
